import axios from 'axios';
import { tecDocUrl, PROVIDER_ID, basicAuth } from 'utils/constantsHelper';
import { langCode } from 'utils/currentLanguage';

const headers = {
  basicData: true,
  attributs: true,
  thumbnails: true,
  replacedByNumbers: true,
  replacedNumbers: true,
  documents: true,
  eanNumbers: true,
  info: true,
  oeNumbers: true,
  prices: false,
  usageNumbers: true,
  mainArticles: true,
  provider: PROVIDER_ID,
};

// @todo: Optimise requests functions.
export const getArtclesInfo = (
  articlesHeaders,
  success,
  error = () => {},
  finallyFn = () => {}
) => {
  axios
    .post(
      tecDocUrl,
      {
        getAssignedArticlesByIds7: {
          lang: langCode,
          ...articlesHeaders,
          ...headers,
        },
      },
      { headers: basicAuth }
    )
    .then(({ status, data: response }) => {
      if (status === 200 && response.status === 200) {
        success(response);
      }
      // Handle Tecdoc error response.
      if (response.status === 400 || response.status === 401) {
        error();
      }
    })
    .catch(() => {
      error();
    })
    .finally(() => {
      finallyFn();
    });
};

export const getAssignedArtclesInfo = (articlesHeaders) => {
  return axios.post(
    tecDocUrl,
    {
      getAssignedArticlesByIds7: {
        lang: langCode,
        ...articlesHeaders,
        ...headers,
      },
    },
    { headers: basicAuth }
  );
};

export const getDirectArticlesInfo = (articlesHeaders) => {
  return axios.post(
    tecDocUrl,
    {
      getDirectArticlesByIds7: {
        lang: langCode,
        ...articlesHeaders,
        ...headers,
      },
    },
    { headers: basicAuth }
  );
};

// Remove this and refactor related components.
export const getDirectArticlesInfoOLD = (
  articlesHeaders,
  success,
  error = () => {}
) => {
  axios
    .post(
      tecDocUrl,
      {
        getDirectArticlesByIds7: {
          lang: langCode,
          ...articlesHeaders,
          ...headers,
        },
      },
      { headers: basicAuth }
    )
    .then(({ status, data: response }) => {
      if (status === 200 && response.status === 200) {
        success(response);
      }
      // Handle Tecdoc error response.
      if (response.status === 400 || response.status === 401) {
        error();
      }
    })
    .catch(() => {
      error();
    });
};



// WEBPACK FOOTER //
// ./src/utils/getArtclesInfo.js